import { Column, Heading, Row, Space, Txt } from '@stenajs-webui/core';
import {
  Icon,
  Link,
  PrimaryButton,
  stenaExclamationCircle,
  stenaRefresh,
} from '@stenajs-webui/elements';
import type { FC, ReactNode } from 'react';
import { CONTACT_URL } from '../footer/Footer';
import { Errors } from '../texts';
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorPage } from './ErrorPage';

interface Props {
  children: ReactNode;
}

export const ErrorPageBoundary: FC<Props> = ({ children }) => (
  <ErrorBoundary
    fallback={() => (
      <ErrorPage
        content={
          <Column alignItems={'flex-start'}>
            <Row alignItems={'center'}>
              <Icon icon={stenaExclamationCircle} />
              <Space />
              <Heading variant={'h2'}>{Errors.ErrorOccurred}</Heading>
            </Row>
            <Txt>{Errors.UnexpectedProblemReloadHint}</Txt>
            <Space num={2} />
            <PrimaryButton
              label={'Reload page'}
              onClick={() => window.location.reload()}
              leftIcon={stenaRefresh}
            />
            <Space num={6} />
            <Txt>
              Please <Link href={CONTACT_URL}>contact your local booking office</Link> if the
              problem persists and you need booking assistance.
            </Txt>
          </Column>
        }
        title={Errors.ErrorOccurred}
      />
    )}
  >
    {children}
  </ErrorBoundary>
);
